import { mapBusinessUnitId } from "common/helpers/v1/machine";
import { UNIVERSAL_PRODUCTS_KEY } from "constants/cart";
import { Machine } from "types";
import { Product } from "types/parts";
import { CartItem } from "types/parts/cart";


export const ComposeCartItem = (
        product: Product,
        machineId: string,
        machine: Machine | string,
        quantity = 1
) : CartItem=>  {
return {
          productId: product.id,
          quantity,
          sku: product.sku,
          priceUnit: product.priceUnit as string,
          price: product.price as number,
          siteRef: product.siteRef as string,
          custNumber: product.custNum as string,
          businessUnitId: mapBusinessUnitId(product.businessUnit) as number || 0,
          procareAllowance: false,
          purchaseOrderRequired: product.isPurchasable ,
          showExactStock: product.showExactStock,
          groupId: machineId as string,
          groupDescription:
             machine === undefined || machineId === UNIVERSAL_PRODUCTS_KEY
              ? UNIVERSAL_PRODUCTS_KEY
               : machine?.description 
        }
}